
const m = window.require("@glimmer/tracking/primitives/cache");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
